import type { OpenSettingsInput } from "@/utils/settingsNavigation";
import { createContext, useContext } from "react";

export type OpenSettingsSource = "ui" | "deep_link" | "quick_action";

const OpenSettingsContext = createContext<
  ((input?: OpenSettingsInput, source?: OpenSettingsSource) => void) | null
>(null);

export function useOpenSettings(): (
  input?: OpenSettingsInput,
  source?: OpenSettingsSource,
) => void {
  const fn = useContext(OpenSettingsContext);
  return fn ?? (() => {});
}

export const OpenSettingsProvider = OpenSettingsContext.Provider;
